import(/* webpackMode: "eager" */ "/Users/mac_de_franck/Desktop/Code/Projects/DOUDOU/frontend/app/page.tsx");
